import styled from 'styled-components'
import {NavLink as Link} from 'react-router-dom'
import DowntownBg from '~/src/assets/images/downtown-bg.jpeg'
import DowntownPa from '~/src/assets/images/Paris.jpg'
import StyledGreeting from '../Greeting'

const ForgotPWLink = styled(Link)`
  color: var(--neutral-800);
  font-size: 11px;
  line-height: 13px;
  text-align: right;
  text-decoration: none;
`

const ForgotPWLinkContainer = styled('div')`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const RegisterLink = styled(Link)`
  color: #005599;
  text-decoration: none;
  margin-bottom: 38px;
`

const FieldContainer = styled('div')`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  margin-top: 40px;
`

const FormTitle = styled('h2')`
  font-size: 2rem;
  font-weight: 700;
  margin-top: 50px;
`

const FormSubtitle = styled('h3')`
  font-size: 1.75rem;
`

const Title = styled('div')`
  text-align: center;
  font-size: 2rem;
  margin-top: 50px;

  @media (min-width: 1024px) {
    text-align: left;
  }
`

const Greeting = styled(StyledGreeting)`
  display: none;

  @media (min-width: 1024px) {
    display: flex;
    justify-content: flex-start;
    padding-top: 70px;
    border-radius: var(--radius-sm) 0 0 var(--radius-sm);
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);

    ${Title}:last-child {
      margin-top: var(--space-5);
      font-weight: 400;
      font-size: 28px;
      line-height: 32px;
    }

    ${RegisterLink} {
      color: inherit;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-bottom: 38px;
      text-decoration: none;
    }
  }
`

const InnerBox = styled('div')`
  background-color: var(--white);
  flex: 1;
  padding: 27px;
  position: relative;

  @media (min-width: 1024px) {
    border-radius: var(--radius-sm);
    grid-column: 2/3;
    grid-row: 1/2;
    min-height: 586px;
    padding: var(--space-8) 130px;
  }
`

const InnerPaper = styled('div')`
  width: 100%;

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 350px auto;
    grid-template-rows: auto 1fr;
  }
`

const Container = styled('div')`
  color: var(--neutral-800);
`

const MaxWidth = styled('div')`
  left: 50%;
  max-width: 890px;
  padding: 30px 9.866%;
  position: relative;
  top: 50%;
  transform: translate(-50%, -50%);

  @media (min-width: 1024px) {
    padding: 0;
  }
`

const Background = styled('div')`
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  background: linear-gradient(rgba(35, 35, 35, 0.64), rgba(35, 35, 35, 0.64)),
    url(${DowntownBg}) center 40% no-repeat;
  background-size: 135%;
`

const BackgroundPa = styled('div')`
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  background: linear-gradient(rgba(35, 35, 35, 0.64), rgba(35, 35, 35, 0.64)),
    url(${DowntownPa}) center 40% no-repeat;
  background-size: 135%;
`

const Outer = styled('div')`
  width: 100%;
  height: 100vh;
  flex: 1;
  overflow: hidden;
`

const VersionNumber = styled('div')`
  display: flex;
  justify-content: right;
  color: #a9a9a9;
`

export default {
  Background,
  BackgroundPa,
  Container,
  FieldContainer,
  ForgotPWLink,
  ForgotPWLinkContainer,
  FormTitle,
  FormSubtitle,
  Greeting,
  InnerPaper,
  InnerBox,
  MaxWidth,
  RegisterLink,
  Outer,
  Title,
  VersionNumber,
}
